<template>
  <v-sheet height="100%" color="bg1" width="100%">
    <v-sheet height="100%" class="rounded-tl-lg overflow-hidden pa-4 d-flex flex-column">
      <div
        class="pa-2 d-flex align-center justify-space-between"
        style="gap: 8px"
        :class="{
          'flex-wrap': $vuetify.breakpoint.xs,
        }">
        <div class="d-flex align-center">
          <h3 class="me-3">Categories</h3>
          <v-sheet :width="$vuetify.breakpoint.xs ? '100%' : 250">
            <v-text-field
              hide-details
              outlined
              dense
              v-model="searchTxt"
              class="search-bar"
              placeholder="Search..."
              clearable
              prepend-inner-icon="mdi-magnify"></v-text-field>
          </v-sheet>
        </div>

        <v-btn color="primary" @click="updateCategory()" v-has="permissions.Categories.Create"
          ><v-icon left>mdi-plus</v-icon> Add Category</v-btn
        >
      </div>
      <v-data-table
        class="elevation-0 pa-2 rounded-0 d-flex flex-column table-sticky custom-table flex-grow-1"
        :headers="headers"
        :search="searchTxt"
        :items="categories">
        <template v-slot:[`item.name`]="{ item }">
          <b style="padding-left: 5px; flex-grow: 1">{{ item.name }}</b
          ><br />
        </template>

        <template v-slot:[`item.color`]="{ item }">
          <v-chip :color="item.color" text-color="#fff" small>
            <v-icon small class="mx-1">mdi-format-color-fill</v-icon> {{ item.color }}
          </v-chip>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-menu dense offset-x right>
            <template v-slot:activator="{ attrs, on }">
              <v-btn icon elevation="0" v-bind="attrs" v-on="on">
                <v-icon size="16px">mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list class="more-options-menu" dense>
              <v-list-item
                v-has="permissions.Categories.Update"
                @click="updateCategory(item)"
                dense>
                <v-list-item-icon class="mr-2 justify-center">
                  <v-icon small color="success">mdi-pencil-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Update</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item
                @click="deleteCategory(item)"
                dense
                v-has="permissions.Categories.Delete">
                <v-list-item-icon class="mr-2 justify-center">
                  <v-icon small color="error">mdi-delete</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Delete</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>

        <template v-slot:no-data>
          <div class="text-center d-flex flex-column">
            <img width="300" src="/img/notFound.svg" class="py-5 my-8" style="opacity: 0.54" />
            <p class="font-weight-medium">No Data Available!</p>
          </div>
        </template>

        <template v-slot:loading>
          <div class="text-center d-flex flex-column">
            <img width="300" src="/img/loading.svg" class="py-5 my-8" style="opacity: 0.54" />
            <p class="font-weight-medium">Loading Categories...</p>
          </div>
        </template>
      </v-data-table>
    </v-sheet>
  </v-sheet>
</template>
<script>
  import { toggleExpandComponent } from '@/scripts/js/forgeviewer';
  import permissions from '@Share/config/permissions';
  import headers from '@Admin/config/categories.headers';

  export default {
    props: ['modelsLoading'],
    name: 'AdminCategories',
    emits: ['update_category', 'delete_category'],
    data() {
      return {
        isExpanded: false,
        permissions,
        headers,
        searchTxt: '',
      };
    },
    methods: {
      toggleExpanded() {
        toggleExpandComponent(this);
      },

      updateCategory(category = null) {
        this.$emit('update_category', category);
      },
      deleteCategory(category) {
        this.$dialog.error({
          text: `Are you sure you want to delete category?`,
          title: `Delete Category`,
          actions: {
            false: 'Cancel',
            true: {
              text: 'Ok',
              color: 'primary',
              handle: () => {
                this.$emit('delete_category', category);
              },
            },
          },
        });
      },
    },
    computed: {
      categories() {
        return this.$store.state.categories;
      },
    },
  };
</script>
<style scoped>
  .v-data-table {
    position: relative;
  }
  .v-data-table .v-data-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: -webkit-fill-available;
  }
</style>
